import "../css/Gallery.css";

const Gallery = () => {
  return (
    <main className="salon-gallery">

      {/* HERO */}
      <section className="gallery-hero">
        <h1>Gallery</h1>
        <p>
          A glimpse into our space,<br />
          our craft, and our calm.
        </p>
      </section>

      {/* GRID */}
      <section className="gallery-grid">
        <div className="gallery-img img1" />
        <div className="gallery-img img2 tall" />
        <div className="gallery-img img3" />
        <div className="gallery-img img4 wide" />
        <div className="gallery-img img5" />
        <div className="gallery-img img6" />
        <div className="gallery-img img7 tall" />
        <div className="gallery-img img8" />
      </section>

      {/* CLOSING */}
      <section className="gallery-closing">
        <p>
          Every detail is intentional.<br />
          Every moment, considered.
        </p>
      </section>

    </main>
  );
};

export default Gallery;
